import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const TeamEdit: React.FC = () => {
    const [searchParams] = useSearchParams();
    const edit = searchParams.get('edit');
    const target = edit ? `/team-management?edit=${encodeURIComponent(edit)}` : '/team-management';

    return <Navigate to={target} replace />;
};

export default TeamEdit;
